import {useI18n} from "@/composables/useI18n";
import {isValidDate} from "@/scripts/Validations/Validations";
import moment from "moment/moment";
import {formatDate} from "@/scripts/Common/helpers";
import {DateFormats} from "@/scripts/Common/DateFormats";

const useDateStringLocalization = () => {

    const {
        d,
    } = useI18n();

    const formatDateBasedOnLocalization = (date: string | undefined, mode: 'short' | 'long') => {
        if (!date || date?.length < 0 || !isValidDate(date)) return '';

        return d(moment(date), mode);
    }

  const localizeDateString = (date: string, format: string) => {
    const formattedDate = formatDate(date, format);
    return formatDateBasedOnLocalization(formattedDate, 'short');
  }

    return {
       formatDateBasedOnLocalization,
       localizeDateString
    }
}


export {
   useDateStringLocalization
}
